"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo, useCallback } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { AuthContext } from "@/components/auth/Auth";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { WaveSmallLeaderboardDrop } from "./WaveSmallLeaderboardDrop";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { useWaveChatScrollOptional } from "@/contexts/wave/WaveChatScrollContext";
interface WaveSmallLeaderboardProps {
  readonly wave: ApiWave;
}
export const WaveSmallLeaderboard: React.FC<WaveSmallLeaderboardProps> = t0 => {
  const $ = _c(24);
  const {
    wave
  } = t0;
  const waveChatScroll = useWaveChatScrollOptional();
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle ?? null;
  let t2;
  if ($[0] !== t1 || $[1] !== wave.id) {
    t2 = {
      waveId: wave.id,
      connectedProfileHandle: t1
    };
    $[0] = t1;
    $[1] = wave.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t2);
  const memoizedDrops = drops;
  let t3;
  if ($[3] !== wave.id || $[4] !== waveChatScroll) {
    t3 = serialNo => {
      waveChatScroll?.requestScrollToSerialNo({
        waveId: wave.id,
        serialNo
      });
    };
    $[3] = wave.id;
    $[4] = waveChatScroll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDropClick = t3;
  let t4;
  if ($[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== isFetching || $[9] !== isFetchingNextPage) {
    t4 = () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = isFetching;
    $[9] = isFetchingNextPage;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const intersectionElementRef = useIntersectionObserver(t4);
  let t5;
  if ($[11] !== handleDropClick || $[12] !== isFetching || $[13] !== memoizedDrops || $[14] !== wave) {
    t5 = memoizedDrops.length === 0 && !isFetching ? <div className="tw-py-4 tw-text-center tw-text-iron-400">No drops have been made yet in this wave</div> : <ul className="tw-space-y-3 tw-pl-0">{memoizedDrops.map(drop => <WaveSmallLeaderboardDrop drop={drop} wave={wave} key={drop.id} onDropClick={() => handleDropClick(drop.serial_no)} />)}</ul>;
    $[11] = handleDropClick;
    $[12] = isFetching;
    $[13] = memoizedDrops;
    $[14] = wave;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isFetchingNextPage) {
    t6 = isFetchingNextPage && <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
    $[16] = isFetchingNextPage;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== intersectionElementRef) {
    t7 = <div ref={intersectionElementRef} />;
    $[18] = intersectionElementRef;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="tw-p-4"><div className="tw-flex tw-flex-col">{t5}{t6}{t7}</div></div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};